/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { ProductResponse } from '../../models/product-response';

export interface ProductControllerGetAll$Params {
  query?: string;
  part_number?: string;
  exclude_products_from_agreement_id?: number;

/**
 * Se impostato, restituisce solo i prodotti presenti in questa commessa (items o asset management collegati).
 */
  include_products_from_agreement_id?: number;
  limit: number;
  skip: number;
  cat_id?: number;
  code_internal?: string;
  code_supplier?: string;
  code_ean?: string;
  brand?: string;
  desc_short?: string;
  name?: string;
  field?: 'name' | 'brand' | 'part_number' | 'related_product_category.name' | 'code_internal' | 'code_supplier' | 'desc_short';
  direction?: 'asc' | 'desc';
  serialized?: boolean;
}

export function productControllerGetAll(http: HttpClient, rootUrl: string, params: ProductControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProductResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, productControllerGetAll.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
    rb.query('part_number', params.part_number, {});
    rb.query('exclude_products_from_agreement_id', params.exclude_products_from_agreement_id, {});
    rb.query('include_products_from_agreement_id', params.include_products_from_agreement_id, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('cat_id', params.cat_id, {});
    rb.query('code_internal', params.code_internal, {});
    rb.query('code_supplier', params.code_supplier, {});
    rb.query('code_ean', params.code_ean, {});
    rb.query('brand', params.brand, {});
    rb.query('desc_short', params.desc_short, {});
    rb.query('name', params.name, {});
    rb.query('field', params.field, {});
    rb.query('direction', params.direction, {});
    rb.query('serialized', params.serialized, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: ProductResponse;
      }>;
    })
  );
}

productControllerGetAll.PATH = '/product';
